import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../../../application";
import { IMPORT_SECTION_OPTION_TYPE } from "../graphql";

const log: any = LoggerModule?.getInstance?.();

export interface IImportCostumeTypeMethods extends IPluginMethodMap {
  importCostumeType(args?: any): Promise<any>;
}

export class ImportCostumeTypeService implements IAgentPlugin {
  readonly methods: IImportCostumeTypeMethods;

  constructor() {
    this.methods = {
      importCostumeType: this.importCostumeType.bind(this),
    };
  }

  async importCostumeType(args: any = {}) {
    const app = VApplication.getInstance();

    const graphqlModule = app.getSync(
      "services.GraphqlServerModule",
    ) as GraphqlServerModule;

    const client = graphqlModule?.getClient?.("graphql-gateway");

    const presentation =
      args?.presentation ?? args?.presentationId ?? args?.filter?.presentation;

    const templateCostumeType =
      args?.templateCostumeType ??
      args?.templateCostumeTypeId ??
      args?.costumeType ??
      args?.costumeTypeId ??
      args?.filter?.templateCostumeType;

    try {
      if (!client) {
        throw new Error("GraphQL client not found.");
      }

      if (!presentation) {
        throw new Error("Missing presentation id.");
      }

      if (!templateCostumeType) {
        throw new Error("Missing template costume type id.");
      }

      const res = await client.mutate({
        mutation: IMPORT_SECTION_OPTION_TYPE,
        variables: {
          filter: {
            presentation,
            templateCostumeType,
          },
        },
      });

      return (
        res?.data?.importSectionOptType ?? {
          success: true,
        }
      );
    } catch (err: any) {
      log?.error?.("error in importCostumeType", err);
      throw err;
    }
  }
}
